import { Card } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';

export default function TourStatusCardSkeleton({ showStackedView = false }) {
  return (
    <SkeletonContainer>
      <Card
        elevated={false}
        css={{
          borderLeftWidth: '3px',
          borderLeftColor: 'gray.300',
          display: 'flex',
          flexDirection: 'column',
          flexFlow: 'column wrap',
          paddingLeft: 'loose',
          paddingRight: 'loose',
        }}
      >
        <Bone type="line" />
        <Bone type="line" css={{ marginTop: 'default' }} />
        {showStackedView && <Bone type="line" css={{ marginTop: 'default' }} />}
      </Card>
    </SkeletonContainer>
  );
}
